var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47915 1.4585C5.04936 1.4585 1.45831 5.04954 1.45831 9.47933V25.521C1.45831 29.9508 5.04936 33.5418 9.47915 33.5418H25.5208C29.9506 33.5418 33.5416 29.9508 33.5416 25.521V9.47933C33.5416 5.04954 29.9506 1.4585 25.5208 1.4585H9.47915ZM17.5 11.6668C14.2783 11.6668 11.6666 14.2785 11.6666 17.5002C11.6666 20.7218 14.2783 23.3335 17.5 23.3335C20.7216 23.3335 23.3333 20.7218 23.3333 17.5002C23.3333 14.2785 20.7216 11.6668 17.5 11.6668ZM8.74998 17.5002C8.74998 12.6677 12.6675 8.75016 17.5 8.75016C22.3325 8.75016 26.25 12.6677 26.25 17.5002C26.25 22.3326 22.3325 26.2502 17.5 26.2502C12.6675 26.2502 8.74998 22.3326 8.74998 17.5002ZM26.25 5.8335C24.6391 5.8335 23.3333 7.13933 23.3333 8.75016C23.3333 10.361 24.6391 11.6668 26.25 11.6668C27.8609 11.6668 29.1666 10.361 29.1666 8.75016C29.1666 7.13933 27.8609 5.8335 26.25 5.8335Z",
    fill: "#C42B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c1ade5956da4dba67a595c1d32b3cad2.svg";
export { ForwardRef as ReactComponent };